import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-lc-table-shell',
  templateUrl: './lc-table-shell.component.html',
  styleUrls: ['./lc-table-shell.component.scss'],
})
export class LcTableShellComponent {
  @Input() loading = false;
  @Input() hasRows = false;
  @Input() refreshMessage = 'Mise à jour…';
}
